import { render } from "./FailedJobs.vue?vue&type=template&id=a5b79758"
import script from "./FailedJobs.vue?vue&type=script&lang=js"
export * from "./FailedJobs.vue?vue&type=script&lang=js"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__